import { makeAction } from "async-action-creator";

import { createApiThunk } from "../../utils/thunk";
import api from "../../utils/api";

export const FETCH_COMPANIES = makeAction("companies/FETCH_COMPANIES");

export const fetchCompanies = createApiThunk({
  action: FETCH_COMPANIES,
  request: (_, { user, company }) => {
    const headquarterId = user.idCompany || company.headquarter;

    if (!headquarterId) return [];

    return api.headquarter.company.list.fetch(headquarterId);
  }
});
